<template>
  <div class="tournamentRound">
    <div class="tournamentRound__header" @click="gotoTournament">
      <TournamentCard :tournament="tournament" />
    </div>

    <section class="tournamentRound__options columns mt-4">
      <span class="tournamentRound__option">
        <b-checkbox v-model="liveOnly" type="is-danger">
          Show just live games ({{
            matches.filter((m) => m.status === "live").length
          }}/{{ matches.length }})
        </b-checkbox>
      </span>
      <span class="tournamentRound__option">
        <div class="tag is-success is-large">Round {{ roundNumber }}</div>
      </span>
      <span class="tournamentRound__option">
        <b-checkbox v-model="showThreats" type="is-danger">
          Show threats
        </b-checkbox>
      </span>
    </section>

    <section class="tournament__boards mt-4">
      <div
        class="tournament__board p-2 mb-5"
        :class="{ 'tournament__board--live': match.status === 'live' }"
        v-for="match in sortedMatches"
        :key="match.id"
        @click="viewMatch(match.id)"
      >
        <GameView :gameId="match.id" :showThreats="showThreats" />
      </div>
    </section>

    <section v-if="tournamentId && roundNumber">
      <RoomSpectators
        :roomId="`Tournament_${tournamentId}-Round_${roundNumber}`"
        :showSpectators="true"
      />
    </section>
  </div>
</template>

<script>
import TournamentCard from "@/components/tournaments/TournamentCard.vue";
import GameView from "@/components/games/GameView.vue";
import RoomSpectators from "@/components/rooms/RoomSpectators.vue";
import { TournamentsAPI } from "@/services/api";
import { firestore } from "@/services/firebase";
import { mapGetters } from "vuex";
import gameUrls from "@/mixins/gameUrls";

const matches = firestore.collection("matches");

export default {
  name: "TournamentRound",

  components: {
    TournamentCard,
    GameView,
    RoomSpectators,
  },

  mixins: [gameUrls],

  data() {
    return {
      tournamentId: null,
      roundNumber: null,
      tournament: {},
      matches: [],
      showThreats: false,
      liveOnly: false,
    };
  },

  computed: {
    ...mapGetters(["getPlayer"]),

    sortedMatches() {
      if (!this.matches || !this.matches.length) return [];
      if (this.liveOnly) {
        return this.matches
          .filter((m) => m.status === "live")
          .sort((a, b) => a.board - b.board);
      }
      return this.matches
        .filter((m) => m.status !== "aborted")
        .sort((a, b) => a.board - b.board);
    },
  },

  methods: {
    async getTournament() {
      if (isNaN(this.tournamentId)) {
        this.$bind(
          "tournament",
          firestore.collection("tournaments").doc(this.tournamentId)
        );
        return;
      }
      await TournamentsAPI.getTournament(this.tournamentId, false).then(
        (data) => {
          if (data) {
            this.tournament = data;
          }
        }
      );
    },

    viewMatch(matchId) {
      this.$router.push({
        path: this.getTournamentGameUrl(this.tournamentId, matchId),
      });
    },

    gotoTournament() {
      this.$router.push({
        path: `/tournaments/${this.tournamentId}`,
      });
    },
  },

  created() {
    this.tournamentId = this.$route.params.tournamentId;
    this.roundNumber = Number(this.$route.params.roundNumber);
    this.liveOnly = !!this.$route.query.live;
    this.$bind(
      "matches",
      matches
        .where("tournamentId", "==", this.tournamentId)
        .where("roundNumber", "==", this.roundNumber)
    );
    this.getTournament();
  },
};
</script>

<style scoped>
.tournamentRound__header {
  cursor: pointer;
}

.tournamentRound__options {
  /* display: flex; */
  justify-content: space-around;
  align-items: center;
}

.tournamentRound__option {
  flex-basis: 25%;
  flex-grow: 0;
}

.tournament__boards {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.tournament__board {
  border: 1px solid lightblue;
  width: 360px;
}

.tournament__board--live {
  border: 2px solid green;
}
</style>
